export type Theme = "light" | "dark";

/**
 * Set the active theme by writing `data-theme` on the document root.
 * With no argument it follows the OS preference.
 */
export function setTheme(theme?: Theme): void {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  if (!theme) {
    root.removeAttribute("data-theme");
    return;
  }
  root.setAttribute("data-theme", theme);
}

/** Read the current theme (explicit attribute, else OS preference). */
export function getTheme(): Theme {
  if (typeof document === "undefined") return "light";
  const attr = document.documentElement.getAttribute("data-theme");
  if (attr === "light" || attr === "dark") return attr;
  return typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

/** Toggle between light and dark; returns the new theme. */
export function toggleTheme(): Theme {
  const next: Theme = getTheme() === "dark" ? "light" : "dark";
  setTheme(next);
  return next;
}
